'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var jacketSizeValues = {
    1: 'XXS',
    2: 'XS',
    3: 'S',
    4: 'M',
    5: 'L',
    6: 'XL',
    7: 'XXL',
    8: 'XXXL',
    9: 'XXXXL',
    10: 'XXXXXL'
};
exports.default = jacketSizeValues;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/jacketSize/jacketSizeValues.js
// module id = 1374
// module chunks = 0